import { css } from '@/styled-system/css';

export const drawerFooterStyles = css.raw({
  flex: '0 0 auto',
  display: 'flex',
  justifyContent: 'flex-end',
  padding: 'default',
});
